export default "__VITE_ASSET__CikDg5Yv__"